import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface AuditReport {
  id: number | string
  name: string
  reportName: string
  auditReportJson: string
  fields: any[]
  inActive: boolean
  inActiveReason: string
  inActiveBy: string
  inActiveDate: string | null
  addedBy: string
  addedDate: string
  updatedBy: string
  updatedDate: string
}

interface AuditReportState {
  auditReports: AuditReport[]
  loading: boolean
  error: string | null
}

const initialState: AuditReportState = {
  auditReports: [],
  loading: false,
  error: null
}

export const auditReportSlice = createSlice({
  name: "auditReport",
  initialState,
  reducers: {
    setAuditReports: (state, action: PayloadAction<AuditReport[]>) => {
      state.auditReports = action.payload
    },
    addAuditReport: (state, action: PayloadAction<AuditReport>) => {
      state.auditReports.push(action.payload)
    },
    updateAuditReport: (state, action: PayloadAction<AuditReport>) => {
      const index = state.auditReports.findIndex(report => report.id === action.payload.id)
      if (index !== -1) {
        state.auditReports[index] = action.payload
      }
    },
    deleteAuditReport: (state, action: PayloadAction<string>) => {
      state.auditReports = state.auditReports.filter(report => report.id !== action.payload)
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    }
  }
})

export const {
  setAuditReports,
  addAuditReport,
  updateAuditReport,
  deleteAuditReport,
  setLoading,
  setError
} = auditReportSlice.actions

export default auditReportSlice.reducer 